<template>
  <div class="login" @keyup.enter="login">
    <h2>{{ $t("auth.welcome") }}</h2>
    <form method="post" action="/auth/login" name="login" :model="loginForm" :rules="rules" ref="loginForm">
      <input type="text" id="email" autocomplete="username email" style="display:none" />
      <input type="password" id="password" autocomplete="current-password" style="display:none" />
      <div class="form-group">
        <div class="input-group">
          <input type="text" id="email_display" v-model="loginForm.username" :placeholder="$t('auth.email')"
            autocomplete="off" required="required" onkeyup="value=value.replace(/\s/g,'')"
            onkeydown="value=value.replace(/\s/g,'')" />
          <i class="bar" />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input :type="isOpen ? 'text' : 'password'" id="password_display" v-model="loginForm.password"
            :placeholder="$t('auth.password')" autocomplete="off" required="required"
            onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')" />
          <i class="bar" />
          <div class="eye-password">
            <img :src="closeEye" alt="" @click="() => { isOpen = true }" v-if="!isOpen" />
            <img :src="openEye" alt="" @click="() => { isOpen = false }" v-if="isOpen" />
          </div>
        </div>
      </div>
      <div id="g-recaptcha-container"></div>
      <p class="g-error" v-if="verified && googleRecaptchaFlag">{{ $t("auth.missingRecaptcha") }}</p>
      <div class="forget-password">
        <span @click="forgetPassword">{{ $t("forgetPassword") }}</span>
      </div>
      <div class="d-flex align--center justify--space-between justify-center">
        <button class="btn btn-primary" :class="{ loading: isLoading }" type="button" id="login" @click="submitForm"
          :disabled="isLoading">
          {{ isLoading ? "" : $t("auth.login") }}
          <Spinner v-if="isLoading" size="small" />
          <span v-if="isLoading" class="spinner-text">{{ $t("loading") }}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import qs from "qs";
import { request, consumeShoplazzaLoginRedirect, syncShoplazzaLoginRedirectOnLoginPage } from "@/utils/utils";
import pageName from "../../NewUser/pageNames";
import Spinner from "vue-simple-spinner";
const Base64 = require("js-base64").Base64;

export default {
  name: "LoginTest",
  components: { Spinner },
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      isLoading: false,
      rules: {},
      token: localStorage.getItem("Authorization"),
      permissions: {
        // [pageName.transactions]: false,
        [pageName.report]: false,
        [pageName.appManagement]: false,
        [pageName.finance]: false,
        [pageName.merchantKyc]: false,
        [pageName.userManagement]: false,
        [pageName.wayBill]: false,
        [pageName.virtualAccount]: false,
        [pageName.download]: false,
      },
      closeEye: require('@/assets/images/eye-close.png'),
      openEye: require('@/assets/images/eye-open.png'),
      isOpen: false,
      recaptchaToken: '',
      verified: false
    };
  },
  computed: {
    googleRecaptchaFlag() {
      return !this.recaptchaToken ? true : false
    }
  },
  methods: {
    ...mapMutations(["changeLogin", "setUser"]),
    login(event) {
      if (event.keyCode === 13 || event.keyCode == 100) {
        this.submitForm();
      }
    },
    route() {
      // 仅 Shoplazza（/plugin/auth-bind + state）回跳；否则保持原逻辑进 PaymentOrder
      const redirect = consumeShoplazzaLoginRedirect(this.$route.query);
      if (redirect) {
        this.$router.push(redirect);
      } else {
        this.$router.push({
          name: "PaymentOrder"
        });
      }
      this.$message({
        duration: 1200,
        message: this.$t("auth.loginSuccess"),
        type: "success"
      });
    },
    getUserData() {
      let that = this
      request({
        method: "post",
        url: "api/dashboard/app/user/query?access_token=" + this.token
      })
        .then(response => {
          if (response.data.code == "10000") {
            let isAdmin =
              response.data.data.role === "MERCHANT_ADMIN" ? true : false;
            if (isAdmin) {
              for (let i in that.permissions) {
                that.permissions[i] = true;
              }
              that.permissions[pageName.finance] = response.data.data.show_finance
                ? true
                : false;
              that.permissions[pageName.virtualAccount] = response.data.data.show_virtual_account
                ? true
                : false;
            } else {
              response.data.data.permission.forEach(item => {
                if (that.permissions[item.name] !== undefined) {
                  that.permissions[item.name] =
                    item.privileges[0] === "View" ? true : false;
                }
              });
              if (!response.data.data.show_finance) {
                that.permissions[pageName.finance] = false;
              }
              if (!response.data.data.show_virtual_account) {
                that.permissions[pageName.virtualAccount] = false;
              }
            }

            that.setUser({
              info: response.data,
              permissions: that.permissions
            });
            localStorage.setItem("userInfo", JSON.stringify({
              info: response.data,
              permissions: that.permissions
            }));
            that.route();
          } else {
            that.$message({
              duration: 2000,
              message: "Opps something went wrong!",
              type: "error"
            });
          }
          that.isLoading = false;
        })
        .catch(err => {
          that.$message({
            duration: 2000,
            message: "Opps something went wrong!",
            type: "error"
          });
          that.isLoading = false;
        });
    },
    submitForm() {
      this.verified = true
      let username = this.loginForm.username;
      let password = this.loginForm.password;
      if (username === "" || password === "") {
        this.$message({
          message: this.$t("auth.loginFail"),
          type: "error"
        });
      } else {
        if (!this.recaptchaToken) return false;
        this.isLoading = true;
        localStorage.setItem("startTime", new Date().getTime());
        localStorage.setItem("sessionTime", 1000);
        const that = this;
        that.$ajax({
          method: "post",
          url: "api/dashboard/login",
          data: qs.stringify({
            username: username,
            password: password
          }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "g_score": this.recaptchaToken
          }
        }).then(response => {
          const envName = process.env.VUE_APP_NAME.toLowerCase()
          window.$setSessionStorage(`${envName}-reset-gt`, 'reset')
          let code = response.data.code;
          if (code == 10000) {
            let data = response.data.data;
            // 鉴权成功
            if (data.dashboard_redirect) {
              const locationHost = window.location.host
              let query = `?_v=${Base64.encode(0)}&_u=${Base64.encode(username)}&_p=${Base64.encode(password)}`
              if (locationHost === `dashboard-test.${envName}.com` || locationHost === 'localhost:8001') {
                // 测试环境
                let hrefQuery = `https://dashboardv2-dev.${envName}.com/303/${query}`
                window.location.href = hrefQuery
              } else {
                // 生产环境
                let hrefQuery = `https://dashboardv2.${envName}.com/303/${query}`
                window.location.href = hrefQuery
              }
              return
            }

            localStorage.setItem("startTime", new Date().getTime());
            if (data.expires_in < 7200) {
              localStorage.setItem("sessionTime", 7200);
            } else {
              localStorage.setItem("sessionTime", data.expires_in);
            }
            localStorage.setItem("refresh_token", data.refresh_token);
            localStorage.setItem("uid", data.uid);
            localStorage.setItem("businessManager", JSON.stringify(data.detail));
            localStorage.setItem("merchantNo", data.detail.merchantNo);
            localStorage.setItem("merchantName", data.merchant_name);
            that.token = data.access_token;
            that.changeLogin({
              Authorization: data.access_token
            });

            // 是否强制密码校验
            let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
            if (!regExpPassword.test(password)) {
              localStorage.setItem("isEasyPassword", true);
            }

            that.getUserData();
          } else if (code == 20002) {
            let data = response.data.data;
            // 返回结果中如果有dashboard_redirect且值是true，跳转到新商户后台 鉴权失败
            if (data && data.dashboard_redirect) {
              const locationHost = window.location.host
              if (locationHost === `dashboard-test.${envName}.com` || locationHost === 'localhost:8001') {
                // 测试环境
                window.location.href = `https://dashboardv2-dev.${envName}.com/forgot-password`
              } else {
                // 生产环境
                window.location.href = `https://dashboardv2.${envName}.com/forgot-password`
              }
              return
            } else {
              // 20002 Bad Credentials 密码错误
              that.$message({
                message: "This password is incorrect. Please try again",
                type: "error"
              });
              that.isLoading = false;
            }
          } else if (code == 20004) {
            // 20004 Permission Denied Google Recaptha校验失败或者IP限制
            that.$message({
              message: "Browser problems",
              type: "error"
            });
            that.isLoading = false;
          } else {
            that.$message({
              message: that.$t("auth.loginFail"),
              type: "error"
            });
            that.isLoading = false;
          }
        }).catch(err => {
          const envName = process.env.VUE_APP_NAME.toLowerCase()
          window.$setSessionStorage(`${envName}-reset-gt`, 'reset')
          that.$message({
            message: "Something unexpected happaned! Please check your network connection!",
            type: "error"
          });
          that.isLoading = false;
        });
      }
    },
    forgetPassword() {
      this.$router.push({ path: "/resetPassword" });
    },
    replaceGoogleRecaptchaDom() {
      const gRecaptchaDom = document.getElementById('g-recaptcha')
      const gRecaptchaContainerDom = document.getElementById('g-recaptcha-container')
      if (!gRecaptchaDom || !gRecaptchaContainerDom) {
        setTimeout(() => {
          this.replaceGoogleRecaptchaDom()
        }, 300)
        return false;
      }
      gRecaptchaDom.style.display = 'block'
      gRecaptchaContainerDom.appendChild(gRecaptchaDom)
    }
  },
  created() {
    // 非 Shoplazza 入口（无 redirect+state）进入登录页时清残留，避免劫持普通登录
    syncShoplazzaLoginRedirectOnLoginPage(this.$route.query)
    window.addEventListener("setItemEvent", (e) => {
      // console.log('监听----e', e)
      const envName = process.env.VUE_APP_NAME.toLowerCase()
      if (e.key === `${envName}-gr-t`) {
        this.recaptchaToken = e.newValue
        this.verified = false
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.replaceGoogleRecaptchaDom()
    })
  }
};
</script>

<style lang="scss">
.g-error {
  color: #ea5455;
}

.loading {
  display: flex;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  text-transform: none;

  .spinner-text {
    font-size: 14px;
    margin-left: 10px;
    color: #ffffff;
  }
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
}

.login {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;

    .down-container {
      display: none;
    }
  }

  h2 {
    text-align: center;
  }

  width: 21.375rem;

  .down-container {
    margin-top: 3.125rem;
  }

  .justify-center {
    justify-content: center;
  }

  .forget-password {
    margin-top: 1rem;
    margin-bottom: 2.25rem;
    text-align: right;
    color: #34495e;

    span {
      cursor: pointer;
    }

    span:hover {
      color: #899c7c;
    }
  }

  .eye-password {
    position: absolute;
    top: 0;
    right: 5px;
    width: 25px;
    cursor: pointer;

    img {
      width: 100%;
      height: auto;
    }
  }
}

@media screen and (max-width: 991px) {
  .d-flex.align--center {
    justify-content: center;
  }
}
</style>
